"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.String = void 0;
var String;
(function (String) {
    String.charAt = (s, i) => s.charAt(i);
    String.charCodeAt = (s, i) => s.charCodeAt(i);
    String.codePointAt = (s, i) => s.codePointAt(i);
    String.concat = (s, ...ss) => s.concat(...ss);
    String.endsWith = (s, c, pos) => s.endsWith(c, pos);
    String.includes = (s, n) => s.includes(n);
    String.indexOf = (s, n) => s.indexOf(n);
    String.lastIndexOf = (s, n) => s.lastIndexOf(n);
    String.localeCompare = (s, n, local, params) => s.localeCompare(n, local, params) === 1;
    String.match = (s, n) => s.match(n);
    String.matchAll = (s, n) => s.matchAll(n);
    String.normalize = (s, n) => s.normalize(n);
    String.padEnd = (s, n, f) => s.padEnd(n, f);
    String.padStart = (s, n, f) => s.padStart(n, f);
    String.repeat = (s, n) => s.repeat(n);
    String.replace = (s, n, ns) => s.replace(n, ns);
    String.search = (s, n) => s.search(n);
    String.slice = (s, start, end) => s.slice(start, end);
    String.split = (s, sep, end) => s.split(sep, end);
    String.startsWith = (s, c, pos) => s.startsWith(c, pos);
    String.substring = (s, start, end) => s.substring(start, end);
    String.toLocaleLowerCase = (s, local) => s.toLocaleLowerCase(local);
    String.toLocaleUpperCase = (s, local) => s.toLocaleUpperCase(local);
    String.toLowerCase = (s) => s.toLowerCase();
    String.toString = (s) => s.toString();
    String.toUpperCase = (s) => s.toUpperCase();
    String.trim = (s) => s.trim();
    String.trimEnd = (s) => s.trimEnd();
    String.trimStart = (s) => s.trimStart();
    String.valueOf = (s) => s.valueOf();
})(String = exports.String || (exports.String = {}));
//# sourceMappingURL=String.js.map